export class WebSocketService {
  constructor(userId, conversationId) {
    this.socket = null;
    this.messageHandlers = new Map();
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000;
    this.userId = userId;
    this.conversationId = conversationId;
  }

  connect() {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      return;
    }

    this.socket = new WebSocket(
      import.meta.env.VITE_WEBSOCKET_URL +
        `?userId=${this.userId}&conversationId=${this.conversationId}`
    );

    this.socket.onopen = () => {
      console.log("WebSocket connected");
      this.reconnectAttempts = 0;
    };

    this.socket.onmessage = (event) => {
      console.log("WebSocket message received:", event.data);
      try {
        const message = JSON.parse(event.data);
        if (message.type === "newMessage") {
          console.log("Processing new message:", message.message);
          this.handleMessage("newMessage", message.message);
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    };

    this.socket.onclose = () => {
      console.log("WebSocket disconnected");
      this.handleReconnect();
    };

    this.socket.onerror = (error) => {
      console.error("WebSocket error:", error);
    };
  }

  handleReconnect() {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      setTimeout(() => {
        console.log(
          `Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})`
        );
        this.connect();
      }, this.reconnectDelay * this.reconnectAttempts);
    }
  }

  send(message) {
    if (this.socket && this.socket.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(message));
    } else {
      console.error("WebSocket is not connected");
    }
  }

  handleMessage(action, data) {
    const handlers = this.messageHandlers.get(action) || [];
    console.log(`Handling ${action} with ${handlers.length} handlers`);
    handlers.forEach((handler) => {
      try {
        handler(data);
      } catch (error) {
        console.error(`Error in message handler for ${action}:`, error);
      }
    });
  }

  subscribe(action, handler) {
    if (!this.messageHandlers.has(action)) {
      this.messageHandlers.set(action, []);
    }
    this.messageHandlers.get(action).push(handler);
    console.log(
      `Subscribed to ${action}, total handlers: ${
        this.messageHandlers.get(action).length
      }`
    );
  }

  unsubscribe(action, handler) {
    if (this.messageHandlers.has(action)) {
      const handlers = this.messageHandlers.get(action);
      const index = handlers.indexOf(handler);
      if (index !== -1) {
        handlers.splice(index, 1);
        console.log(
          `Unsubscribed from ${action}, remaining handlers: ${handlers.length}`
        );
      }
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }
}
